module.exports = "/assets/logo_sg_substance_3d_stager-3d7ff86e30572ea2df9752e563a4a727.png";